import { PureComponent, Fragment } from 'react';
import elementType from 'prop-types-extra/lib/elementType';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import Layout from 'components/page/Layout';
import Head from 'components/Head';
import { DOMAIN_PREFIX } from 'helpers/fieldOptions/domainPrefix';

import ExtraFiltersContent from './content/ExtraFiltersContent';

import Form from './Form';
import { reducer } from './duck';
import * as actions from './actions';
import { SEARCH_ADS_FORM } from './constants';
import mapStateToProps from './mapStateToProps';
import SearchContent from './content/SearchContent';

/* external props:
 *
 *   LeftSide: elementType,
 *   beforeExtraFiltersOpened: PropTypes.func,
 *   breadcrumbs: PropTypes.object.isRequired,
 *   breadcrumbsHtml: PropTypes.string,
 *   changeFilters: PropTypes.func.isRequired,
 *   changePage: PropTypes.func.isRequired,
 *   changeSort: PropTypes.func.isRequired,
 *   cms: PropTypes.object,
 *   initialForm: PropTypes.object,
 *   layoutError: PropTypes.object,
 *   withExtraFilters: PropTypes.bool,
 *   withPromoBanner: PropTypes.bool.isRequired,
 *
 *  */

class SearchLayout extends PureComponent {
  static propTypes = {
    applyFilters: PropTypes.func.isRequired,
    applyFiltersByAdvSearchSubmit: PropTypes.func.isRequired,
    applyFiltersByChangedValue: PropTypes.func.isRequired,
    applyFiltersByModalSubmit: PropTypes.func.isRequired,
    applySort: PropTypes.func.isRequired,
    beforeExtraFiltersOpened: PropTypes.func,
    breadcrumbs: PropTypes.array.isRequired,
    breadcrumbsHtml: PropTypes.string,
    changeFilters: PropTypes.func.isRequired,
    changePage: PropTypes.func.isRequired,
    changeSort: PropTypes.func.isRequired,
    clearAllFilters: PropTypes.func.isRequired,
    closeModalFilters: PropTypes.func.isRequired,
    cms: PropTypes.object,
    destroy: PropTypes.func.isRequired,
    experiment: PropTypes.object,
    extraFiltersContentProps: PropTypes.object.isRequired,
    headProps: PropTypes.object.isRequired,
    initialForm: PropTypes.object.isRequired,
    restoreLastSearch: PropTypes.func.isRequired,
    isExtraFiltersOpened: PropTypes.bool,
    isLoaded: PropTypes.bool.isRequired,
    layoutError: PropTypes.object,
    LeftSide: elementType,
    loadPage: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    openExtraFilters: PropTypes.func.isRequired,
    removeAllExtraFilters: PropTypes.func.isRequired,
    removeExtraFiltersItem: PropTypes.func.isRequired,
    removeFilterItem: PropTypes.func.isRequired,
    onDislikeAd: PropTypes.func.isRequired,
    saveLastSearch: PropTypes.func.isRequired,
    searchContentProps: PropTypes.object,
    storageKey: PropTypes.string.isRequired,
    showModalFilters: PropTypes.func.isRequired,
    toggleAdFavorite: PropTypes.func.isRequired,
    withExtraFilters: PropTypes.bool,
    withInitialAdResultsAmount: PropTypes.bool,
    withMerchantInfo: PropTypes.bool,
  };

  componentDidMount() {
    const { storageKey, restoreLastSearch, location } = this.props;
    // If we have stored key and on main search page.
    const shouldRestoreSearch =
      storageKey && location.pathname === `/${DOMAIN_PREFIX}/`;

    if (shouldRestoreSearch) {
      restoreLastSearch(storageKey);
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {
      location: { search },
      storageKey,
      saveLastSearch,
    } = this.props;
    const {
      location: { search: nextSearch },
    } = nextProps;

    if (search !== nextSearch && storageKey) {
      saveLastSearch(storageKey);
    }
  }

  componentWillUnmount() {
    const { destroy } = this.props;

    destroy();
  }

  handleExtraFiltersOpen = () => {
    const { openExtraFilters, beforeExtraFiltersOpened } = this.props;

    openExtraFilters(beforeExtraFiltersOpened);
  };

  handleLoadPageClick = (...args) => {
    const { loadPage, changePage } = this.props;

    return loadPage(changePage, ...args);
  };

  handleAdvFiltersSubmit = () => {
    const { applyFiltersByAdvSearchSubmit, changeFilters } = this.props;

    applyFiltersByAdvSearchSubmit({ changeFilters });
  };

  handleFilterRemove = ({ form, name: fieldName }) => {
    const { removeFilterItem, changeFilters } = this.props;

    removeFilterItem({ changeFilters, form, fieldName });
  };

  handleRemoveAllFiltersClick = () => {
    const { clearAllFilters, changeFilters } = this.props;

    clearAllFilters({ changeFilters });
  };

  handleSortChanged = () => {
    const { applySort, changeSort } = this.props;

    return applySort(changeSort);
  };

  handleFiltersModalSubmit = () => {
    const { applyFiltersByModalSubmit, changeFilters } = this.props;

    applyFiltersByModalSubmit(changeFilters);
  };

  handleFiltersChanged = () => {
    const { applyFiltersByChangedValue, changeFilters } = this.props;

    applyFiltersByChangedValue(changeFilters);
  };

  renderContent() {
    const {
      closeModalFilters,
      extraFiltersContentProps,
      headProps,
      initialForm,
      isExtraFiltersOpened,
      isLoaded,
      onDislikeAd,
      removeAllExtraFilters,
      removeExtraFiltersItem,
      searchContentProps,
      showModalFilters,
      toggleAdFavorite,
    } = this.props;

    if (!isLoaded) {
      return null;
    }

    return (
      <Form
        enableReinitialize
        form={SEARCH_ADS_FORM}
        initialValues={initialForm}
      >
        <Head {...headProps} />

        {isExtraFiltersOpened ? (
          <ExtraFiltersContent
            {...extraFiltersContentProps}
            onAdvFiltersSubmit={this.handleAdvFiltersSubmit}
            onFiltersItemRemove={removeExtraFiltersItem}
            onRemoveAll={removeAllExtraFilters}
          />
        ) : (
          <SearchContent
            {...searchContentProps}
            onExtraFiltersOpen={this.handleExtraFiltersOpen}
            onFilterRemove={this.handleFilterRemove}
            onFiltersChanged={this.handleFiltersChanged}
            onFiltersModalClose={closeModalFilters}
            onFiltersModalShow={showModalFilters}
            onFiltersModalSubmit={this.handleFiltersModalSubmit}
            onLoadPageClick={this.handleLoadPageClick}
            onRemoveAllFiltersClick={this.handleRemoveAllFiltersClick}
            onSortChanged={this.handleSortChanged}
            onToggleAdFavoriteClick={toggleAdFavorite}
            onToggleAdDislikeClick={onDislikeAd}
          />
        )}
      </Form>
    );
  }

  render() {
    const { layoutError, experiment } = this.props;

    return (
      <Fragment>
        <Layout
          content={this.renderContent()}
          error={layoutError}
          experiment={experiment}
        />
      </Fragment>
    );
  }
}

export default withRouter(connect(mapStateToProps, actions)(SearchLayout));

export { actions, reducer };
